export default __webpack_public_path__ + "images/moderation-alert-icon.addb1e099acba3993792d515ca6d98b3.svg";